import { spawn } from "redux-saga/effects";

import commentsSaga from "./comments/comments.saga";
import documentPreviewSaga from "./documentPreview/documentPreview.saga";
import documentSearchSaga from "./documentSearch/documentSearch.saga";
import entityNavigationSaga from "./entityNavigation/entityNavigation.saga";
import linkDocumentSaga from "./linkDocument/linkDocument.saga";
import onSaveSaga from "./onSave.saga";
import publishSaga from "./publish/publish.saga";

export default function* transactionsSaga() {
  yield spawn(commentsSaga);
  yield spawn(publishSaga);
  yield spawn(entityNavigationSaga);
  yield spawn(documentPreviewSaga);
  yield spawn(documentSearchSaga);
  yield spawn(linkDocumentSaga);
  yield spawn(onSaveSaga);
}
